import {createReducer} from '../utils';
import {default as types} from '../constants';

const initialState = {
    token: null,
    userName: null,
    isAuthenticated: false,
    isAuthenticating: false,
    statusText: null
};

export default createReducer(initialState, {
    [types.LOGIN_USER_REQUEST]: (state, payload) => {
        return Object.assign({}, state, {
            'isAuthenticating': true,
            'statusText': null
        });
    },
    [types.LOGIN_USER_SUCCESS]: (state, payload) => {
        return Object.assign({}, state, {
            'isAuthenticating': false,
            'isAuthenticated': true,
            'token': payload.token,
            'userName': payload.userName,
            'statusText': 'You have been successfully logged in.'
        });

    },
    [types.LOGIN_USER_FAILURE]: (state, payload) => {
        return Object.assign({}, state, {
            'isAuthenticating': false,
            'isAuthenticated': false,
            'token': null,
            'userName': null,
            'statusText': `Authentication Error: ${payload.status} ${payload.statusText}`
        });
    },
    [types.LOGOUT_USER]: (state, payload) => {
        return Object.assign({}, state, {
            'isAuthenticated': false,
            'token': null,
            'userName': null,
            'statusText': 'You have been successfully logged out.'
        });
    },
    [types.CHANGE_USER_NAME]: (state, payload) => {
        localStorage.setItem('userName', payload.name);
        return Object.assign({}, state, {
            'userName': payload.name,
        });
    }
});


/** WEBPACK FOOTER **
 ** ./js/reducers/auth.js
 **/